<div class="content">
	<table mat-table [dataSource]="dataSource" >

		<ng-container matColumnDef="name">
			<th mat-header-cell *matHeaderCellDef>Tool</th>
			<td mat-cell *matCellDef="let row" >
				<div>{{ row.name}}</div>
			</td>
		</ng-container>

		<ng-container matColumnDef="run">
			<th mat-header-cell *matHeaderCellDef>Run</th>
			<td mat-cell *matCellDef="let row" >
				<button mat-icon-button (click)="runTool(row)">
					<mat-icon>play_arrow</mat-icon>
				</button>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns;" >
		</tr>
	</table>
</div>
@if(resultsVisible) {
	<textarea class="results" [(ngModel)]="textAreaValue" ></textarea>
}
